import { RecordProperties } from './../../record-model';
import { LayoutService } from './../../layout.service';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { RecordModel, RecordCategory, RecordLine } from '../../record-model';
import {
  ModuleStructure,
  Field,
  Section,
  FieldDataType,
  FieldPCAlignment,
} from 'src/app/models/module-structure';

@Component({
  selector: 'app-field, [app-field]',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.less'],
})
export class FieldComponent implements OnInit, OnDestroy {
  @Input() moduleStructure: ModuleStructure;
  @Input() field: Field;
  @Input() recordModel: RecordModel;
  @Input() section: Section;
  @Input() lineId = 0;
  @Input() forceLabelVisible = false;
  @Input() actionType = '';
  @Input() inTable = false;
  @Input() parentClass = '';

  initialized = false;
  scanControlVal: any;

  @Input() recordProperty: RecordProperties;
  @Input() recordCategory: RecordCategory;
  @Input() recordLine: RecordLine;

  @Input() set scanControl(val: any) {
    this.scanControlVal = val;
  }

  get scanControl() {
    return this.scanControlVal;
  }

  FieldDataType = FieldDataType;

  labelWidth = 6;
  inputWidth = 14;

  screenSize = '';

  constructor(private layoutService: LayoutService) {}
  ngOnDestroy(): void {}

  ngOnInit(): void {
    const date = new Date();

    if (!this.recordCategory) {
      this.recordCategory = this.recordModel.Categories.find(
        (c) => c.Id === this.section.XmlTagName
      );
    }

    if (!this.recordLine) {
      this.recordLine = this.recordCategory.Lines.find(
        (l) => l.Id === this.lineId
      );
    }

    if (!this.recordProperty && this.recordLine.Properties !== undefined) {
      this.recordProperty = this.recordLine.Properties.find(
        (c) => c.Name === this.field.PropertyName
      );
    }

    if (this.recordProperty == null) {
      return;
    }
    this.recordProperty.InTable = this.inTable;
    this.screenSize = this.layoutService.screenSize;
    this.adjustWidth();

    // this.layoutService.screenSizeEmitter.subscribe((a) => {
    //   this.screenSize = a;
    //   this.adjustWidth();
    // });
  }

  adjustWidth() {
    if (
      (this.section.Type === 2 && !this.forceLabelVisible) ||
      !this.field.AdditionalInformationParsed.LabelVisible
    ) {
      this.inputWidth = 24;
    } else if (
      this.screenSize === 'large' ||
      this.screenSize === 'x-large' ||
      this.screenSize === 'medium'
    ) {
      if (this.field.PCAlignment === FieldPCAlignment.Extended) {
        this.labelWidth = 4;
        this.inputWidth = 20;
      } else {
        this.labelWidth = 10;
        this.inputWidth = 14;
      }
    } else if (this.screenSize === 'medium') {
      this.labelWidth = 6;
      this.inputWidth = 18;
    } else {
      this.labelWidth = 24;
      this.inputWidth = 24;
    }
  }

  mouseLeave() {
    this.recordProperty.EditMode = false;
  }

  mouseEnter() {
    this.recordProperty.EditMode = true;
    this.initialized = true;
  }
}
